import {
  get_rem14pbkv8p42gid as get_rem,
  get_systemDefaultFont25t9j5zn5vlep as get_systemDefaultFont,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
  divc3x3x4wqw206 as div,
  times16x024lmmohdt as times,
  ImageSource1gw5x4v78u21a as ImageSource,
} from './data.commonHtml.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { get_px1lajc6xaddk2r as get_px_0 } from './data.js.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.dot_1 = new (Icon())(get_rem(1.5), get_rem(1.5), -240, -1200, 1440, 1440, listOf('M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z'));
        this.help_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z'));
        this.upload_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M440-200h80v-167l64 64 56-57-160-160-160 160 57 56 63-63v167ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z'));
        this.search_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z'));
        this.home_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z'));
        this.menu_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z'));
        this.close_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z'));
        this.settings_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z'));
        this.done_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z'));
        this.add_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z'));
        this.delete_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z'));
        this.arrowBack_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z'));
        this.chevronRight_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z'));
        this.chevronLeft_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z'));
        this.chevronDown_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M480-456 664-640l56 56-240 240-240-240 56-56 184 184Z'));
        this.logout_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z'));
        this.login_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M480-120v-80h280v-560H480v-80h280q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H480Zm-80-160-55-58 102-102H120v-80h327L345-622l55-58 200 200-200 200Z'));
        this.moreHoriz_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z'));
        this.moreVert_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z'));
        this.deleteForever_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('m376-300 104-104 104 104 56-56-104-104 104-104-56-56-104 104-104-104-56 56 104 104-104 104 56 56Zm-96 180q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520Zm-400 0v520-520Z'));
        this.remove_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M200-440v-80h560v80H200Z'));
        this.download_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z'));
        this.sync_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M160-160v-80h110l-16-14q-52-46-73-105t-21-119q0-111 66.5-197.5T400-790v84q-72 26-116 88.5T240-478q0 45 17 87.5t53 78.5l10 10v-98h80v240H160Zm400-10v-84q72-26 116-88.5T720-482q0-45-17-87.5T650-648l-10-10v98h-80v-240h240v80H690l16 14q49 49 71.5 106.5T800-482q0 111-66.5 197.5T560-170Z'));
        this.block_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z'));
        this.sort_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M320-440v-287L217-624l-57-56 200-200 200 200-57 56-103-103v287h-80ZM600-80 400-280l57-56 103 103v-287h80v287l103-103 57 56L600-80Z'));
        this.filterList_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M400-240v-80h160v80H400ZM240-440v-80h480v80H240ZM120-640v-80h720v80H120Z'));
        this.star_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('m354-247 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-80l65-281L80-550l288-25 112-265 112 265 288 25-218 189 65 281-247-149L233-80Zm247-350Z'));
        this.starFilled_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('m233-80 65-281L80-550l288-25 112-265 112 265 288 25-218 189 65 281-247-149L233-80Z'));
        this.person_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z'));
        this.group_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z'));
        this.warning_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z'));
        this.send_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z'));
        this.chat_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z'));
        this.list_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M360-200v-80h480v80H360Zm0-240v-80h480v80H360Zm0-240v-80h480v80H360ZM200-160q-33 0-56.5-23.5T120-240q0-33 23.5-56.5T200-320q33 0 56.5 23.5T280-240q0 33-23.5 56.5T200-160Zm0-240q-33 0-56.5-23.5T120-480q0-33 23.5-56.5T200-560q33 0 56.5 23.5T280-480q0 33-23.5 56.5T200-400Zm0-240q-33 0-56.5-23.5T120-720q0-33 23.5-56.5T200-800q33 0 56.5 23.5T280-720q0 33-23.5 56.5T200-640Z'));
        this.notificationFilled_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160ZM480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Z'));
        this.notification_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z'));
        this.email_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z'));
        this.certification_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('m387-412 35-114-92-74h114l36-112 36 112h114l-93 74 35 114-92-71-93 71ZM240-40v-309q-38-42-59-96t-21-115q0-134 93-227t227-93q134 0 227 93t93 227q0 61-21 115t-59 96v309l-240-80-240 80Zm240-280q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70ZM320-159l160-41 160 41v-124q-35 20-75.5 31.5T480-240q-44 0-84.5-11.5T320-283v124Zm160-62Z'));
        this.copy_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z'));
        this.lightMode_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M480-360q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm0 80q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Zm326-268Z'));
        this.darkMode_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z'));
        this.info_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z'));
        this.externalLink_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z'));
        this.expand_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M200-200v-240h80v160h160v80H200Zm480-320v-160H520v-80h240v240h-80Z'));
        this.collapse_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M440-440v240h-80v-160H200v-80h240Zm160-320v160h160v80H520v-240h80Z'));
        this.passkey_1 = new (Icon())(get_rem(1.5), get_rem(1.5), 0, -960, 960, 960, listOf('M120-160v-112q0-34 17.5-62.5T184-378q62-31 126-46.5T440-440q20 0 40 1.5t40 4.5q-4 58 21 109.5t73 84.5v80H120ZM760-40l-60-60v-186q-44-13-72-49.5T600-420q0-58 41-99t99-41q58 0 99 41t41 99q0 45-25.5 80T790-290l50 50-60 60 60 60-80 80ZM440-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm300 80q17 0 28.5-11.5T780-440q0-17-11.5-28.5T740-480q-17 0-28.5 11.5T700-440q0 17 11.5 28.5T740-400Z'));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var IconClass;
function Icon() {
  if (IconClass === VOID) {
    class $ {
      constructor(width, height, viewBoxMinX, viewBoxMinY, viewBoxWidth, viewBoxHeight, pathDatas, strokePathDatas) {
        Companion_getInstance();
        viewBoxMinX = viewBoxMinX === VOID ? 0 : viewBoxMinX;
        viewBoxMinY = viewBoxMinY === VOID ? 0 : viewBoxMinY;
        viewBoxWidth = viewBoxWidth === VOID ? 24 : viewBoxWidth;
        viewBoxHeight = viewBoxHeight === VOID ? 24 : viewBoxHeight;
        var tmp;
        if (pathDatas === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = pathDatas;
        }
        pathDatas = tmp;
        var tmp_0;
        if (strokePathDatas === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_0 = emptyList();
        } else {
          tmp_0 = strokePathDatas;
        }
        strokePathDatas = tmp_0;
        this.width_1 = width;
        this.height_1 = height;
        this.viewBoxMinX_1 = viewBoxMinX;
        this.viewBoxMinY_1 = viewBoxMinY;
        this.viewBoxWidth_1 = viewBoxWidth;
        this.viewBoxHeight_1 = viewBoxHeight;
        this.pathDatas_1 = pathDatas;
        this.strokePathDatas_1 = strokePathDatas;
      }
      toImageSource_vhg6iu_k$(color) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.pathDatas_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = new (Path())(color, null, 0.0, null, item);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        var tmp = destination;
        // Inline function 'kotlin.collections.map' call
        var this_1 = this.strokePathDatas_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
        var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
          var tmp$ret$5 = new (Path())(item_0.fill_1, get_px_0(item_0.strokeWidth_1) > 0.0 ? color.closestColor_akwbqu_k$() : null, get_px_0(item_0.strokeWidth_1), item_0.strokeLineCap_1, item_0.path_1);
          destination_0.add_utx5q5_k$(tmp$ret$5);
        }
        return ImageVector().new_com_lightningkite_kiteui_models_ImageVector_l2afuq_k$(this.width_1, this.height_1, this.viewBoxMinX_1, this.viewBoxMinY_1, this.viewBoxWidth_1, this.viewBoxHeight_1, plus(tmp, destination_0));
      }
      resize_q1xpz0_k$(size) {
        return this.copy$default_cqy5mq_k$(size, size);
      }
      copy_cdhccy_k$(width, height, viewBoxMinX, viewBoxMinY, viewBoxWidth, viewBoxHeight, pathDatas, strokePathDatas) {
        return new (Icon())(width, height, viewBoxMinX, viewBoxMinY, viewBoxWidth, viewBoxHeight, pathDatas, strokePathDatas);
      }
      copy$default_cqy5mq_k$(width, height, viewBoxMinX, viewBoxMinY, viewBoxWidth, viewBoxHeight, pathDatas, strokePathDatas, $super) {
        width = width === VOID ? this.width_1 : width;
        height = height === VOID ? this.height_1 : height;
        viewBoxMinX = viewBoxMinX === VOID ? this.viewBoxMinX_1 : viewBoxMinX;
        viewBoxMinY = viewBoxMinY === VOID ? this.viewBoxMinY_1 : viewBoxMinY;
        viewBoxWidth = viewBoxWidth === VOID ? this.viewBoxWidth_1 : viewBoxWidth;
        viewBoxHeight = viewBoxHeight === VOID ? this.viewBoxHeight_1 : viewBoxHeight;
        pathDatas = pathDatas === VOID ? this.pathDatas_1 : pathDatas;
        strokePathDatas = strokePathDatas === VOID ? this.strokePathDatas_1 : strokePathDatas;
        return $super === VOID ? this.copy_cdhccy_k$(width, height, viewBoxMinX, viewBoxMinY, viewBoxWidth, viewBoxHeight, pathDatas, strokePathDatas) : $super.copy_cdhccy_k$.call(this, new (Dimension())(width), new (Dimension())(height), viewBoxMinX, viewBoxMinY, viewBoxWidth, viewBoxHeight, pathDatas, strokePathDatas);
      }
      toString() {
        return 'Icon(width=' + Dimension__toString_impl_o4q1ad(this.width_1) + ', height=' + Dimension__toString_impl_o4q1ad(this.height_1) + ', viewBoxMinX=' + this.viewBoxMinX_1 + ', viewBoxMinY=' + this.viewBoxMinY_1 + ', viewBoxWidth=' + this.viewBoxWidth_1 + ', viewBoxHeight=' + this.viewBoxHeight_1 + ', pathDatas=' + toString(this.pathDatas_1) + ', strokePathDatas=' + toString(this.strokePathDatas_1) + ')';
      }
      hashCode() {
        var result = Dimension__hashCode_impl_p583vw(this.width_1);
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.height_1) | 0;
        result = imul(result, 31) + this.viewBoxMinX_1 | 0;
        result = imul(result, 31) + this.viewBoxMinY_1 | 0;
        result = imul(result, 31) + this.viewBoxWidth_1 | 0;
        result = imul(result, 31) + this.viewBoxHeight_1 | 0;
        result = imul(result, 31) + hashCode(this.pathDatas_1) | 0;
        result = imul(result, 31) + hashCode(this.strokePathDatas_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Icon()))
          return false;
        if (!equals(this.width_1, other.width_1))
          return false;
        if (!equals(this.height_1, other.height_1))
          return false;
        if (!(this.viewBoxMinX_1 === other.viewBoxMinX_1))
          return false;
        if (!(this.viewBoxMinY_1 === other.viewBoxMinY_1))
          return false;
        if (!(this.viewBoxWidth_1 === other.viewBoxWidth_1))
          return false;
        if (!(this.viewBoxHeight_1 === other.viewBoxHeight_1))
          return false;
        if (!equals(this.pathDatas_1, other.pathDatas_1))
          return false;
        if (!equals(this.strokePathDatas_1, other.strokePathDatas_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Icon');
    IconClass = $;
  }
  return IconClass;
}
function _Dimension___init__impl__44fy0d(value) {
  return value;
}
function _Dimension___get_value__impl__urhqzr($this) {
  return $this;
}
function Dimension__compareTo_impl_gsceod($this, other) {
  return compareTo(get_px_0($this), get_px_0(other));
}
function Dimension__compareTo_impl_gsceod_0($this, other) {
  return Dimension__compareTo_impl_gsceod($this.value_1, other instanceof Dimension() ? other.value_1 : THROW_CCE());
}
function Dimension__toString_impl_o4q1ad($this) {
  return 'Dimension(value=' + $this.toString() + ')';
}
function Dimension__hashCode_impl_p583vw($this) {
  return $this.hashCode();
}
function Dimension__equals_impl_3qjzew($this, other) {
  if (!(other instanceof Dimension()))
    return false;
  var tmp0_other_with_cast = other.value_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var DimensionClass;
function Dimension() {
  if (DimensionClass === VOID) {
    class $ {
      constructor(value) {
        this.value_1 = value;
      }
      compareTo_k92ed4_k$(other) {
        return Dimension__compareTo_impl_gsceod(this.value_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Dimension__compareTo_impl_gsceod_0(this, other);
      }
      toString() {
        return Dimension__toString_impl_o4q1ad(this.value_1);
      }
      hashCode() {
        return Dimension__hashCode_impl_p583vw(this.value_1);
      }
      equals(other) {
        return Dimension__equals_impl_3qjzew(this.value_1, other);
      }
    }
    initMetadataForClass($, 'Dimension', VOID, VOID, [Comparable()]);
    DimensionClass = $;
  }
  return DimensionClass;
}
var NotClass;
function Not() {
  if (NotClass === VOID) {
    class $ {}
    initMetadataForClass($, 'Not');
    NotClass = $;
  }
  return NotClass;
}
var AndClass;
function And() {
  if (AndClass === VOID) {
    class $ {
      constructor(queries) {
        this.queries_1 = queries;
      }
      toString() {
        return 'And(queries=' + toString(this.queries_1) + ')';
      }
      hashCode() {
        return hashCode(this.queries_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof And()))
          return false;
        if (!equals(this.queries_1, other.queries_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'And');
    AndClass = $;
  }
  return AndClass;
}
var OrClass;
function Or() {
  if (OrClass === VOID) {
    class $ {}
    initMetadataForClass($, 'Or');
    OrClass = $;
  }
  return OrClass;
}
var MinAspectRatioClass;
function MinAspectRatio() {
  if (MinAspectRatioClass === VOID) {
    class $ {}
    initMetadataForClass($, 'MinAspectRatio');
    MinAspectRatioClass = $;
  }
  return MinAspectRatioClass;
}
var MaxAspectRatioClass;
function MaxAspectRatio() {
  if (MaxAspectRatioClass === VOID) {
    class $ {}
    initMetadataForClass($, 'MaxAspectRatio');
    MaxAspectRatioClass = $;
  }
  return MaxAspectRatioClass;
}
var MinWidthClass;
function MinWidth() {
  if (MinWidthClass === VOID) {
    class $ {
      constructor(dimension) {
        this.dimension_1 = dimension;
      }
      toString() {
        return 'MinWidth(dimension=' + Dimension__toString_impl_o4q1ad(this.dimension_1) + ')';
      }
      hashCode() {
        return Dimension__hashCode_impl_p583vw(this.dimension_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MinWidth()))
          return false;
        if (!equals(this.dimension_1, other.dimension_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MinWidth');
    MinWidthClass = $;
  }
  return MinWidthClass;
}
var MaxWidthClass;
function MaxWidth() {
  if (MaxWidthClass === VOID) {
    class $ {
      constructor(dimension) {
        this.dimension_1 = dimension;
      }
      toString() {
        return 'MaxWidth(dimension=' + Dimension__toString_impl_o4q1ad(this.dimension_1) + ')';
      }
      hashCode() {
        return Dimension__hashCode_impl_p583vw(this.dimension_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MaxWidth()))
          return false;
        if (!equals(this.dimension_1, other.dimension_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MaxWidth');
    MaxWidthClass = $;
  }
  return MaxWidthClass;
}
var MinHeightClass;
function MinHeight() {
  if (MinHeightClass === VOID) {
    class $ {}
    initMetadataForClass($, 'MinHeight');
    MinHeightClass = $;
  }
  return MinHeightClass;
}
var MaxHeightClass;
function MaxHeight() {
  if (MaxHeightClass === VOID) {
    class $ {}
    initMetadataForClass($, 'MaxHeight');
    MaxHeightClass = $;
  }
  return MaxHeightClass;
}
var UpdateClass;
function Update() {
  if (UpdateClass === VOID) {
    class $ {}
    initMetadataForClass($, 'Update');
    UpdateClass = $;
  }
  return UpdateClass;
}
var HoverClass;
function Hover() {
  if (HoverClass === VOID) {
    class $ {}
    initMetadataForClass($, 'Hover');
    HoverClass = $;
  }
  return HoverClass;
}
var DisplayModeClass;
function DisplayMode() {
  if (DisplayModeClass === VOID) {
    class $ {}
    initMetadataForClass($, 'DisplayMode');
    DisplayModeClass = $;
  }
  return DisplayModeClass;
}
var PointerClass;
function Pointer() {
  if (PointerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'Pointer');
    PointerClass = $;
  }
  return PointerClass;
}
var FontAndStyleClass;
function FontAndStyle() {
  if (FontAndStyleClass === VOID) {
    class $ {
      constructor(font, italic, weight, allCaps, lineSpacingMultiplier, additionalLetterSpacing, size, strikethrough, underline, align) {
        font = font === VOID ? get_systemDefaultFont() : font;
        italic = italic === VOID ? false : italic;
        weight = weight === VOID ? 400 : weight;
        allCaps = allCaps === VOID ? false : allCaps;
        lineSpacingMultiplier = lineSpacingMultiplier === VOID ? 1.4 : lineSpacingMultiplier;
        additionalLetterSpacing = additionalLetterSpacing === VOID ? get_px(0) : additionalLetterSpacing;
        size = size === VOID ? get_rem_0(1) : size;
        strikethrough = strikethrough === VOID ? false : strikethrough;
        underline = underline === VOID ? false : underline;
        align = align === VOID ? Align_Start_getInstance() : align;
        this.font_1 = font;
        this.italic_1 = italic;
        this.weight_1 = weight;
        this.allCaps_1 = allCaps;
        this.lineSpacingMultiplier_1 = lineSpacingMultiplier;
        this.additionalLetterSpacing_1 = additionalLetterSpacing;
        this.size_1 = size;
        this.strikethrough_1 = strikethrough;
        this.underline_1 = underline;
        this.align_1 = align;
      }
      copy_yvvbe2_k$(font, italic, bold, allCaps, lineSpacingMultiplier, additionalLetterSpacing) {
        var tmp0_weight = bold ? 700 : 400;
        return this.copy$default_cfilcw_k$(font, italic, tmp0_weight, allCaps, lineSpacingMultiplier, additionalLetterSpacing);
      }
      copy$default_d05kcn_k$(font, italic, bold, allCaps, lineSpacingMultiplier, additionalLetterSpacing, $super) {
        font = font === VOID ? this.font_1 : font;
        italic = italic === VOID ? this.italic_1 : italic;
        allCaps = allCaps === VOID ? this.allCaps_1 : allCaps;
        lineSpacingMultiplier = lineSpacingMultiplier === VOID ? this.lineSpacingMultiplier_1 : lineSpacingMultiplier;
        additionalLetterSpacing = additionalLetterSpacing === VOID ? this.additionalLetterSpacing_1 : additionalLetterSpacing;
        return $super === VOID ? this.copy_yvvbe2_k$(font, italic, bold, allCaps, lineSpacingMultiplier, additionalLetterSpacing) : $super.copy_yvvbe2_k$.call(this, font, italic, bold, allCaps, lineSpacingMultiplier, new (Dimension())(additionalLetterSpacing));
      }
      copy_qcf7z4_k$(font, italic, weight, allCaps, lineSpacingMultiplier, additionalLetterSpacing, size, strikethrough, underline, align) {
        return new (FontAndStyle())(font, italic, weight, allCaps, lineSpacingMultiplier, additionalLetterSpacing, size, strikethrough, underline, align);
      }
      copy$default_cfilcw_k$(font, italic, weight, allCaps, lineSpacingMultiplier, additionalLetterSpacing, size, strikethrough, underline, align, $super) {
        font = font === VOID ? this.font_1 : font;
        italic = italic === VOID ? this.italic_1 : italic;
        weight = weight === VOID ? this.weight_1 : weight;
        allCaps = allCaps === VOID ? this.allCaps_1 : allCaps;
        lineSpacingMultiplier = lineSpacingMultiplier === VOID ? this.lineSpacingMultiplier_1 : lineSpacingMultiplier;
        additionalLetterSpacing = additionalLetterSpacing === VOID ? this.additionalLetterSpacing_1 : additionalLetterSpacing;
        size = size === VOID ? this.size_1 : size;
        strikethrough = strikethrough === VOID ? this.strikethrough_1 : strikethrough;
        underline = underline === VOID ? this.underline_1 : underline;
        align = align === VOID ? this.align_1 : align;
        return $super === VOID ? this.copy_qcf7z4_k$(font, italic, weight, allCaps, lineSpacingMultiplier, additionalLetterSpacing, size, strikethrough, underline, align) : $super.copy_qcf7z4_k$.call(this, font, italic, weight, allCaps, lineSpacingMultiplier, new (Dimension())(additionalLetterSpacing), new (Dimension())(size), strikethrough, underline, align);
      }
      toString() {
        return 'FontAndStyle(font=' + this.font_1.toString() + ', italic=' + this.italic_1 + ', weight=' + this.weight_1 + ', allCaps=' + this.allCaps_1 + ', lineSpacingMultiplier=' + this.lineSpacingMultiplier_1 + ', additionalLetterSpacing=' + Dimension__toString_impl_o4q1ad(this.additionalLetterSpacing_1) + ', size=' + Dimension__toString_impl_o4q1ad(this.size_1) + ', strikethrough=' + this.strikethrough_1 + ', underline=' + this.underline_1 + ', align=' + this.align_1.toString() + ')';
      }
      hashCode() {
        var result = this.font_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.italic_1) | 0;
        result = imul(result, 31) + this.weight_1 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.allCaps_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.lineSpacingMultiplier_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.additionalLetterSpacing_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.size_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.strikethrough_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.underline_1) | 0;
        result = imul(result, 31) + this.align_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FontAndStyle()))
          return false;
        if (!this.font_1.equals(other.font_1))
          return false;
        if (!(this.italic_1 === other.italic_1))
          return false;
        if (!(this.weight_1 === other.weight_1))
          return false;
        if (!(this.allCaps_1 === other.allCaps_1))
          return false;
        if (!equals(this.lineSpacingMultiplier_1, other.lineSpacingMultiplier_1))
          return false;
        if (!equals(this.additionalLetterSpacing_1, other.additionalLetterSpacing_1))
          return false;
        if (!equals(this.size_1, other.size_1))
          return false;
        if (!(this.strikethrough_1 === other.strikethrough_1))
          return false;
        if (!(this.underline_1 === other.underline_1))
          return false;
        if (!this.align_1.equals(other.align_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'FontAndStyle', FontAndStyle);
    FontAndStyleClass = $;
  }
  return FontAndStyleClass;
}
function div_0(_this__u8e3s4, other) {
  return div(_this__u8e3s4, other);
}
function times_0(_this__u8e3s4, other) {
  return times(_this__u8e3s4, other);
}
var PathClass;
function Path() {
  if (PathClass === VOID) {
    class $ {
      constructor(fillColor, strokeColor, strokeWidth, strokeCap, path) {
        fillColor = fillColor === VOID ? null : fillColor;
        strokeColor = strokeColor === VOID ? null : strokeColor;
        strokeWidth = strokeWidth === VOID ? null : strokeWidth;
        strokeCap = strokeCap === VOID ? null : strokeCap;
        this.fillColor_1 = fillColor;
        this.strokeColor_1 = strokeColor;
        this.strokeWidth_1 = strokeWidth;
        this.strokeCap_1 = strokeCap;
        this.path_1 = path;
      }
      toString() {
        return 'Path(fillColor=' + toString_0(this.fillColor_1) + ', strokeColor=' + toString_0(this.strokeColor_1) + ', strokeWidth=' + this.strokeWidth_1 + ', strokeCap=' + toString_0(this.strokeCap_1) + ', path=' + this.path_1 + ')';
      }
      hashCode() {
        var result = this.fillColor_1 == null ? 0 : hashCode(this.fillColor_1);
        result = imul(result, 31) + (this.strokeColor_1 == null ? 0 : this.strokeColor_1.hashCode()) | 0;
        result = imul(result, 31) + (this.strokeWidth_1 == null ? 0 : getNumberHashCode(this.strokeWidth_1)) | 0;
        result = imul(result, 31) + (this.strokeCap_1 == null ? 0 : this.strokeCap_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.path_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Path()))
          return false;
        if (!equals(this.fillColor_1, other.fillColor_1))
          return false;
        if (!equals(this.strokeColor_1, other.strokeColor_1))
          return false;
        if (!equals(this.strokeWidth_1, other.strokeWidth_1))
          return false;
        if (!equals(this.strokeCap_1, other.strokeCap_1))
          return false;
        if (!(this.path_1 === other.path_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Path');
    PathClass = $;
  }
  return PathClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var ImageVectorClass;
function ImageVector() {
  if (ImageVectorClass === VOID) {
    class $ extends ImageSource() {
      constructor(width, height, viewBoxMinX, viewBoxMinY, viewBoxWidth, viewBoxHeight, paths) {
        return new.target.new_com_lightningkite_kiteui_models_ImageVector_l2afuq_k$(width, height, viewBoxMinX, viewBoxMinY, viewBoxWidth, viewBoxHeight, paths);
      }
      static new_com_lightningkite_kiteui_models_ImageVector_l2afuq_k$(width, height, viewBoxMinX, viewBoxMinY, viewBoxWidth, viewBoxHeight, paths) {
        viewBoxMinX = viewBoxMinX === VOID ? 0 : viewBoxMinX;
        viewBoxMinY = viewBoxMinY === VOID ? 0 : viewBoxMinY;
        viewBoxWidth = viewBoxWidth === VOID ? 24 : viewBoxWidth;
        viewBoxHeight = viewBoxHeight === VOID ? 24 : viewBoxHeight;
        var $this = this.new_com_lightningkite_kiteui_models_ImageSource_p790jq_k$();
        $this.width_1 = width;
        $this.height_1 = height;
        $this.viewBoxMinX_1 = viewBoxMinX;
        $this.viewBoxMinY_1 = viewBoxMinY;
        $this.viewBoxWidth_1 = viewBoxWidth;
        $this.viewBoxHeight_1 = viewBoxHeight;
        $this.paths_1 = paths;
        return $this;
      }
      toString() {
        return 'ImageVector(width=' + Dimension__toString_impl_o4q1ad(this.width_1) + ', height=' + Dimension__toString_impl_o4q1ad(this.height_1) + ', viewBoxMinX=' + this.viewBoxMinX_1 + ', viewBoxMinY=' + this.viewBoxMinY_1 + ', viewBoxWidth=' + this.viewBoxWidth_1 + ', viewBoxHeight=' + this.viewBoxHeight_1 + ', paths=' + toString(this.paths_1) + ')';
      }
      hashCode() {
        var result = Dimension__hashCode_impl_p583vw(this.width_1);
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.height_1) | 0;
        result = imul(result, 31) + this.viewBoxMinX_1 | 0;
        result = imul(result, 31) + this.viewBoxMinY_1 | 0;
        result = imul(result, 31) + this.viewBoxWidth_1 | 0;
        result = imul(result, 31) + this.viewBoxHeight_1 | 0;
        result = imul(result, 31) + hashCode(this.paths_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ImageVector()))
          return false;
        if (!equals(this.width_1, other.width_1))
          return false;
        if (!equals(this.height_1, other.height_1))
          return false;
        if (!(this.viewBoxMinX_1 === other.viewBoxMinX_1))
          return false;
        if (!(this.viewBoxMinY_1 === other.viewBoxMinY_1))
          return false;
        if (!(this.viewBoxWidth_1 === other.viewBoxWidth_1))
          return false;
        if (!(this.viewBoxHeight_1 === other.viewBoxHeight_1))
          return false;
        if (!equals(this.paths_1, other.paths_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ImageVector');
    ImageVectorClass = $;
  }
  return ImageVectorClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Align_Start_instance = new (Align())('Start', 0, true, false);
  Align_Center_instance = new (Align())('Center', 1, false, false);
  Align_End_instance = new (Align())('End', 2, false, true);
  Align_Stretch_instance = new (Align())('Stretch', 3, true, true);
}
var Align_Start_instance;
var Align_Center_instance;
var Align_End_instance;
var Align_Stretch_instance;
function values() {
  static_init();
  return [Align_Start_getInstance(), Align_Center_getInstance(), Align_End_getInstance(), Align_Stretch_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var $ENTRIES;
var AlignClass;
function Align() {
  if (AlignClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, touchesStart, touchesEnd) {
        super(name, ordinal);
        this.touchesStart_1 = touchesStart;
        this.touchesEnd_1 = touchesEnd;
      }
    }
    initMetadataForClass($, 'Align');
    AlignClass = $;
  }
  return AlignClass;
}
var SizeConstraintsClass;
function SizeConstraints() {
  if (SizeConstraintsClass === VOID) {
    class $ {
      constructor(minWidth, maxWidth, minHeight, maxHeight, aspectRatio, width, height) {
        minWidth = minWidth === VOID ? null : minWidth;
        maxWidth = maxWidth === VOID ? null : maxWidth;
        minHeight = minHeight === VOID ? null : minHeight;
        maxHeight = maxHeight === VOID ? null : maxHeight;
        aspectRatio = aspectRatio === VOID ? null : aspectRatio;
        width = width === VOID ? null : width;
        height = height === VOID ? null : height;
        this.minWidth_1 = minWidth;
        this.maxWidth_1 = maxWidth;
        this.minHeight_1 = minHeight;
        this.maxHeight_1 = maxHeight;
        this.aspectRatio_1 = aspectRatio;
        this.width_1 = width;
        this.height_1 = height;
      }
      toString() {
        var tmp = this.minWidth_1;
        var tmp_0 = toString_0(tmp == null ? null : new (Dimension())(tmp));
        var tmp_1 = this.maxWidth_1;
        var tmp_2 = toString_0(tmp_1 == null ? null : new (Dimension())(tmp_1));
        var tmp_3 = this.minHeight_1;
        var tmp_4 = toString_0(tmp_3 == null ? null : new (Dimension())(tmp_3));
        var tmp_5 = this.maxHeight_1;
        var tmp_6 = toString_0(tmp_5 == null ? null : new (Dimension())(tmp_5));
        var tmp_7 = this.width_1;
        var tmp_8 = toString_0(tmp_7 == null ? null : new (Dimension())(tmp_7));
        var tmp_9 = this.height_1;
        return 'SizeConstraints(minWidth=' + tmp_0 + ', maxWidth=' + tmp_2 + ', minHeight=' + tmp_4 + ', maxHeight=' + tmp_6 + ', aspectRatio=' + this.aspectRatio_1 + ', width=' + tmp_8 + ', height=' + toString_0(tmp_9 == null ? null : new (Dimension())(tmp_9)) + ')';
      }
      hashCode() {
        var tmp;
        var tmp_0 = this.minWidth_1;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          tmp = 0;
        } else {
          tmp = Dimension__hashCode_impl_p583vw(this.minWidth_1);
        }
        var result = tmp;
        var tmp_1 = imul(result, 31);
        var tmp_2;
        var tmp_3 = this.maxWidth_1;
        if ((tmp_3 == null ? null : new (Dimension())(tmp_3)) == null) {
          tmp_2 = 0;
        } else {
          tmp_2 = Dimension__hashCode_impl_p583vw(this.maxWidth_1);
        }
        result = tmp_1 + tmp_2 | 0;
        var tmp_4 = imul(result, 31);
        var tmp_5;
        var tmp_6 = this.minHeight_1;
        if ((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null) {
          tmp_5 = 0;
        } else {
          tmp_5 = Dimension__hashCode_impl_p583vw(this.minHeight_1);
        }
        result = tmp_4 + tmp_5 | 0;
        var tmp_7 = imul(result, 31);
        var tmp_8;
        var tmp_9 = this.maxHeight_1;
        if ((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null) {
          tmp_8 = 0;
        } else {
          tmp_8 = Dimension__hashCode_impl_p583vw(this.maxHeight_1);
        }
        result = tmp_7 + tmp_8 | 0;
        result = imul(result, 31) + (this.aspectRatio_1 == null ? 0 : getNumberHashCode(this.aspectRatio_1)) | 0;
        var tmp_10 = imul(result, 31);
        var tmp_11;
        var tmp_12 = this.width_1;
        if ((tmp_12 == null ? null : new (Dimension())(tmp_12)) == null) {
          tmp_11 = 0;
        } else {
          tmp_11 = Dimension__hashCode_impl_p583vw(this.width_1);
        }
        result = tmp_10 + tmp_11 | 0;
        var tmp_13 = imul(result, 31);
        var tmp_14;
        var tmp_15 = this.height_1;
        if ((tmp_15 == null ? null : new (Dimension())(tmp_15)) == null) {
          tmp_14 = 0;
        } else {
          tmp_14 = Dimension__hashCode_impl_p583vw(this.height_1);
        }
        result = tmp_13 + tmp_14 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SizeConstraints()))
          return false;
        var tmp = this.minWidth_1;
        var tmp_0 = tmp == null ? null : new (Dimension())(tmp);
        var tmp_1 = other.minWidth_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (Dimension())(tmp_1)))
          return false;
        var tmp_2 = this.maxWidth_1;
        var tmp_3 = tmp_2 == null ? null : new (Dimension())(tmp_2);
        var tmp_4 = other.maxWidth_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (Dimension())(tmp_4)))
          return false;
        var tmp_5 = this.minHeight_1;
        var tmp_6 = tmp_5 == null ? null : new (Dimension())(tmp_5);
        var tmp_7 = other.minHeight_1;
        if (!equals(tmp_6, tmp_7 == null ? null : new (Dimension())(tmp_7)))
          return false;
        var tmp_8 = this.maxHeight_1;
        var tmp_9 = tmp_8 == null ? null : new (Dimension())(tmp_8);
        var tmp_10 = other.maxHeight_1;
        if (!equals(tmp_9, tmp_10 == null ? null : new (Dimension())(tmp_10)))
          return false;
        if (!equals(this.aspectRatio_1, other.aspectRatio_1))
          return false;
        var tmp_11 = this.width_1;
        var tmp_12 = tmp_11 == null ? null : new (Dimension())(tmp_11);
        var tmp_13 = other.width_1;
        if (!equals(tmp_12, tmp_13 == null ? null : new (Dimension())(tmp_13)))
          return false;
        var tmp_14 = this.height_1;
        var tmp_15 = tmp_14 == null ? null : new (Dimension())(tmp_14);
        var tmp_16 = other.height_1;
        if (!equals(tmp_15, tmp_16 == null ? null : new (Dimension())(tmp_16)))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SizeConstraints', SizeConstraints);
    SizeConstraintsClass = $;
  }
  return SizeConstraintsClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.belowRight_1 = new (PopoverPreferredDirection())(false, true, Align_End_getInstance());
        this.belowLeft_1 = new (PopoverPreferredDirection())(false, true, Align_Start_getInstance());
        this.belowCenter_1 = new (PopoverPreferredDirection())(false, true, Align_Center_getInstance());
        this.aboveRight_1 = new (PopoverPreferredDirection())(false, false, Align_End_getInstance());
        this.aboveLeft_1 = new (PopoverPreferredDirection())(false, false, Align_Start_getInstance());
        this.aboveCenter_1 = new (PopoverPreferredDirection())(false, false, Align_Center_getInstance());
        this.rightBottom_1 = new (PopoverPreferredDirection())(true, true, Align_End_getInstance());
        this.rightTop_1 = new (PopoverPreferredDirection())(true, true, Align_Start_getInstance());
        this.rightCenter_1 = new (PopoverPreferredDirection())(true, true, Align_Center_getInstance());
        this.leftBottom_1 = new (PopoverPreferredDirection())(true, false, Align_End_getInstance());
        this.leftTop_1 = new (PopoverPreferredDirection())(true, false, Align_Start_getInstance());
        this.leftCenter_1 = new (PopoverPreferredDirection())(true, false, Align_Center_getInstance());
        this.all_1 = listOf_0([this.belowRight_1, this.belowLeft_1, this.belowCenter_1, this.aboveRight_1, this.aboveLeft_1, this.aboveCenter_1, this.rightBottom_1, this.rightTop_1, this.rightCenter_1, this.leftBottom_1, this.leftTop_1, this.leftCenter_1]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var PopoverPreferredDirectionClass;
function PopoverPreferredDirection() {
  if (PopoverPreferredDirectionClass === VOID) {
    class $ {
      constructor(horizontal, after, align) {
        Companion_getInstance_1();
        horizontal = horizontal === VOID ? false : horizontal;
        after = after === VOID ? true : after;
        align = align === VOID ? Align_End_getInstance() : align;
        this.horizontal_1 = horizontal;
        this.after_1 = after;
        this.align_1 = align;
      }
      copy_rm27zg_k$(horizontal, after, align) {
        return new (PopoverPreferredDirection())(horizontal, after, align);
      }
      copy$default_jo50x_k$(horizontal, after, align, $super) {
        horizontal = horizontal === VOID ? this.horizontal_1 : horizontal;
        after = after === VOID ? this.after_1 : after;
        align = align === VOID ? this.align_1 : align;
        return $super === VOID ? this.copy_rm27zg_k$(horizontal, after, align) : $super.copy_rm27zg_k$.call(this, horizontal, after, align);
      }
      toString() {
        return 'PopoverPreferredDirection(horizontal=' + this.horizontal_1 + ', after=' + this.after_1 + ', align=' + this.align_1.toString() + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.horizontal_1);
        result = imul(result, 31) + getBooleanHashCode(this.after_1) | 0;
        result = imul(result, 31) + this.align_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PopoverPreferredDirection()))
          return false;
        if (!(this.horizontal_1 === other.horizontal_1))
          return false;
        if (!(this.after_1 === other.after_1))
          return false;
        if (!this.align_1.equals(other.align_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PopoverPreferredDirection', PopoverPreferredDirection);
    PopoverPreferredDirectionClass = $;
  }
  return PopoverPreferredDirectionClass;
}
var static_init_called_0;
function static_init_0() {
  if (static_init_called_0)
    return Unit_instance;
  static_init_called_0 = true;
  WordBreak_Normal_instance = new (WordBreak())('Normal', 0);
  WordBreak_BreakAll_instance = new (WordBreak())('BreakAll', 1);
}
var WordBreak_Normal_instance;
var WordBreak_BreakAll_instance;
var WordBreakClass;
function WordBreak() {
  if (WordBreakClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'WordBreak');
    WordBreakClass = $;
  }
  return WordBreakClass;
}
function times_1(_this__u8e3s4, other) {
  return times(_this__u8e3s4, other);
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        this.paragraph_1 = new (KeyboardHints())(KeyboardCase_Sentences_getInstance(), KeyboardType_Text_getInstance());
        this.title_1 = new (KeyboardHints())(KeyboardCase_Words_getInstance(), KeyboardType_Text_getInstance());
        this.id_1 = new (KeyboardHints())(KeyboardCase_Letters_getInstance(), KeyboardType_Text_getInstance(), VOID, VOID, false);
        this.integer_1 = new (KeyboardHints())(KeyboardCase_None_getInstance(), KeyboardType_Integer_getInstance());
        this.integerWithNegative_1 = new (KeyboardHints())(KeyboardCase_None_getInstance(), KeyboardType_IntegerWithNegative_getInstance());
        this.decimal_1 = new (KeyboardHints())(KeyboardCase_None_getInstance(), KeyboardType_Decimal_getInstance());
        this.decimalWithNegative_1 = new (KeyboardHints())(KeyboardCase_None_getInstance(), KeyboardType_DecimalWithNegative_getInstance());
        this.phone_1 = new (KeyboardHints())(KeyboardCase_None_getInstance(), KeyboardType_Phone_getInstance());
        this.email_1 = new (KeyboardHints())(KeyboardCase_None_getInstance(), KeyboardType_Email_getInstance(), AutoComplete_Email_getInstance(), VOID, false);
        this.password_1 = new (KeyboardHints())(VOID, VOID, AutoComplete_Password_getInstance(), VOID, false);
        this.newPassword_1 = new (KeyboardHints())(VOID, VOID, AutoComplete_NewPassword_getInstance(), VOID, false);
        this.oneTimeCode_1 = new (KeyboardHints())(KeyboardCase_Letters_getInstance(), KeyboardType_Text_getInstance(), AutoComplete_OneTimeCode_getInstance(), VOID, false);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var KeyboardHintsClass;
function KeyboardHints() {
  if (KeyboardHintsClass === VOID) {
    class $ {
      constructor(case_0, type, autocomplete, includePasskeys, autocorrect) {
        Companion_getInstance_2();
        case_0 = case_0 === VOID ? KeyboardCase_None_getInstance() : case_0;
        type = type === VOID ? KeyboardType_Text_getInstance() : type;
        autocomplete = autocomplete === VOID ? null : autocomplete;
        includePasskeys = includePasskeys === VOID ? false : includePasskeys;
        autocorrect = autocorrect === VOID ? true : autocorrect;
        this.case_1 = case_0;
        this.type_1 = type;
        this.autocomplete_1 = autocomplete;
        this.includePasskeys_1 = includePasskeys;
        this.autocorrect_1 = autocorrect;
      }
      copy_5glbh2_k$(case_0, type, autocomplete, includePasskeys, autocorrect) {
        return new (KeyboardHints())(case_0, type, autocomplete, includePasskeys, autocorrect);
      }
      copy$default_zb1eab_k$(case_0, type, autocomplete, includePasskeys, autocorrect, $super) {
        case_0 = case_0 === VOID ? this.case_1 : case_0;
        type = type === VOID ? this.type_1 : type;
        autocomplete = autocomplete === VOID ? this.autocomplete_1 : autocomplete;
        includePasskeys = includePasskeys === VOID ? this.includePasskeys_1 : includePasskeys;
        autocorrect = autocorrect === VOID ? this.autocorrect_1 : autocorrect;
        return $super === VOID ? this.copy_5glbh2_k$(case_0, type, autocomplete, includePasskeys, autocorrect) : $super.copy_5glbh2_k$.call(this, case_0, type, autocomplete, includePasskeys, autocorrect);
      }
      toString() {
        return 'KeyboardHints(case=' + this.case_1.toString() + ', type=' + this.type_1.toString() + ', autocomplete=' + toString_0(this.autocomplete_1) + ', includePasskeys=' + this.includePasskeys_1 + ', autocorrect=' + this.autocorrect_1 + ')';
      }
      hashCode() {
        var result = this.case_1.hashCode();
        result = imul(result, 31) + this.type_1.hashCode() | 0;
        result = imul(result, 31) + (this.autocomplete_1 == null ? 0 : this.autocomplete_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.includePasskeys_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.autocorrect_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KeyboardHints()))
          return false;
        if (!this.case_1.equals(other.case_1))
          return false;
        if (!this.type_1.equals(other.type_1))
          return false;
        if (!equals(this.autocomplete_1, other.autocomplete_1))
          return false;
        if (!(this.includePasskeys_1 === other.includePasskeys_1))
          return false;
        if (!(this.autocorrect_1 === other.autocorrect_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KeyboardHints', KeyboardHints);
    KeyboardHintsClass = $;
  }
  return KeyboardHintsClass;
}
var ImageLocalClass;
function ImageLocal() {
  if (ImageLocalClass === VOID) {
    class $ extends ImageSource() {
      constructor(file) {
        return new.target.new_com_lightningkite_kiteui_models_ImageLocal_dt7oni_k$(file);
      }
      static new_com_lightningkite_kiteui_models_ImageLocal_dt7oni_k$(file) {
        var $this = this.new_com_lightningkite_kiteui_models_ImageSource_p790jq_k$();
        $this.file_1 = file;
        return $this;
      }
      toString() {
        return 'ImageLocal(file=' + toString(this.file_1) + ')';
      }
      hashCode() {
        return hashCode(this.file_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ImageLocal()))
          return false;
        if (!equals(this.file_1, other.file_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ImageLocal');
    ImageLocalClass = $;
  }
  return ImageLocalClass;
}
var ImageRemoteClass;
function ImageRemote() {
  if (ImageRemoteClass === VOID) {
    class $ extends ImageSource() {
      constructor(url, cacheStrategy) {
        return new.target.new_com_lightningkite_kiteui_models_ImageRemote_pyaztv_k$(url, cacheStrategy);
      }
      static new_com_lightningkite_kiteui_models_ImageRemote_pyaztv_k$(url, cacheStrategy) {
        var $this = this.new_com_lightningkite_kiteui_models_ImageSource_p790jq_k$();
        $this.url_1 = url;
        $this.cacheStrategy_1 = cacheStrategy;
        return $this;
      }
      static new_com_lightningkite_kiteui_models_ImageRemote_yzp06t_k$(url) {
        return this.new_com_lightningkite_kiteui_models_ImageRemote_pyaztv_k$(url, UrlCacheStrategy_Full_getInstance());
      }
      toString() {
        return 'ImageRemote(url=' + this.url_1 + ', cacheStrategy=' + this.cacheStrategy_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.url_1);
        result = imul(result, 31) + this.cacheStrategy_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ImageRemote()))
          return false;
        if (!(this.url_1 === other.url_1))
          return false;
        if (!this.cacheStrategy_1.equals(other.cacheStrategy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ImageRemote');
    ImageRemoteClass = $;
  }
  return ImageRemoteClass;
}
var static_init_called_1;
function static_init_1() {
  if (static_init_called_1)
    return Unit_instance;
  static_init_called_1 = true;
  KeyboardCase_None_instance = new (KeyboardCase())('None', 0);
  KeyboardCase_Letters_instance = new (KeyboardCase())('Letters', 1);
  KeyboardCase_Words_instance = new (KeyboardCase())('Words', 2);
  KeyboardCase_Sentences_instance = new (KeyboardCase())('Sentences', 3);
}
var KeyboardCase_None_instance;
var KeyboardCase_Letters_instance;
var KeyboardCase_Words_instance;
var KeyboardCase_Sentences_instance;
var KeyboardCaseClass;
function KeyboardCase() {
  if (KeyboardCaseClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'KeyboardCase');
    KeyboardCaseClass = $;
  }
  return KeyboardCaseClass;
}
var static_init_called_2;
function static_init_2() {
  if (static_init_called_2)
    return Unit_instance;
  static_init_called_2 = true;
  KeyboardType_Text_instance = new (KeyboardType())('Text', 0);
  KeyboardType_Integer_instance = new (KeyboardType())('Integer', 1, false);
  KeyboardType_Phone_instance = new (KeyboardType())('Phone', 2);
  KeyboardType_Decimal_instance = new (KeyboardType())('Decimal', 3, true);
  KeyboardType_Email_instance = new (KeyboardType())('Email', 4);
  KeyboardType_IntegerWithNegative_instance = new (KeyboardType())('IntegerWithNegative', 5);
  KeyboardType_DecimalWithNegative_instance = new (KeyboardType())('DecimalWithNegative', 6);
}
var KeyboardType_Text_instance;
var KeyboardType_Integer_instance;
var KeyboardType_Phone_instance;
var KeyboardType_Decimal_instance;
var KeyboardType_Email_instance;
var KeyboardType_IntegerWithNegative_instance;
var KeyboardType_DecimalWithNegative_instance;
var KeyboardTypeClass;
function KeyboardType() {
  if (KeyboardTypeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, allowDecimal) {
        allowDecimal = allowDecimal === VOID ? true : allowDecimal;
        super(name, ordinal);
        this.allowDecimal_1 = allowDecimal;
      }
    }
    initMetadataForClass($, 'KeyboardType');
    KeyboardTypeClass = $;
  }
  return KeyboardTypeClass;
}
var static_init_called_3;
function static_init_3() {
  if (static_init_called_3)
    return Unit_instance;
  static_init_called_3 = true;
  AutoComplete_Email_instance = new (AutoComplete())('Email', 0);
  AutoComplete_Password_instance = new (AutoComplete())('Password', 1);
  AutoComplete_NewPassword_instance = new (AutoComplete())('NewPassword', 2);
  AutoComplete_Phone_instance = new (AutoComplete())('Phone', 3);
  AutoComplete_OneTimeCode_instance = new (AutoComplete())('OneTimeCode', 4);
}
var AutoComplete_Email_instance;
var AutoComplete_Password_instance;
var AutoComplete_NewPassword_instance;
var AutoComplete_Phone_instance;
var AutoComplete_OneTimeCode_instance;
var AutoCompleteClass;
function AutoComplete() {
  if (AutoCompleteClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'AutoComplete');
    AutoCompleteClass = $;
  }
  return AutoCompleteClass;
}
var static_init_called_4;
function static_init_4() {
  if (static_init_called_4)
    return Unit_instance;
  static_init_called_4 = true;
  UrlCacheStrategy_None_instance = new (UrlCacheStrategy())('None', 0);
  UrlCacheStrategy_Full_instance = new (UrlCacheStrategy())('Full', 1);
  UrlCacheStrategy_PathOnly_instance = new (UrlCacheStrategy())('PathOnly', 2);
}
var UrlCacheStrategy_None_instance;
var UrlCacheStrategy_Full_instance;
var UrlCacheStrategy_PathOnly_instance;
var UrlCacheStrategyClass;
function UrlCacheStrategy() {
  if (UrlCacheStrategyClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'UrlCacheStrategy');
    UrlCacheStrategyClass = $;
  }
  return UrlCacheStrategyClass;
}
var static_init_called_5;
function static_init_5() {
  if (static_init_called_5)
    return Unit_instance;
  static_init_called_5 = true;
  ImageScaleType_Fit_instance = new (ImageScaleType())('Fit', 0);
  ImageScaleType_Crop_instance = new (ImageScaleType())('Crop', 1);
  ImageScaleType_Stretch_instance = new (ImageScaleType())('Stretch', 2);
  ImageScaleType_NoScale_instance = new (ImageScaleType())('NoScale', 3);
}
var ImageScaleType_Fit_instance;
var ImageScaleType_Crop_instance;
var ImageScaleType_Stretch_instance;
var ImageScaleType_NoScale_instance;
var ImageScaleTypeClass;
function ImageScaleType() {
  if (ImageScaleTypeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'ImageScaleType');
    ImageScaleTypeClass = $;
  }
  return ImageScaleTypeClass;
}
var ImageRawClass;
function ImageRaw() {
  if (ImageRawClass === VOID) {
    class $ extends ImageSource() {}
    initMetadataForClass($, 'ImageRaw');
    ImageRawClass = $;
  }
  return ImageRawClass;
}
function Align_Start_getInstance() {
  static_init();
  return Align_Start_instance;
}
function Align_Center_getInstance() {
  static_init();
  return Align_Center_instance;
}
function Align_End_getInstance() {
  static_init();
  return Align_End_instance;
}
function Align_Stretch_getInstance() {
  static_init();
  return Align_Stretch_instance;
}
function WordBreak_Normal_getInstance() {
  static_init_0();
  return WordBreak_Normal_instance;
}
function KeyboardCase_None_getInstance() {
  static_init_1();
  return KeyboardCase_None_instance;
}
function KeyboardCase_Letters_getInstance() {
  static_init_1();
  return KeyboardCase_Letters_instance;
}
function KeyboardCase_Words_getInstance() {
  static_init_1();
  return KeyboardCase_Words_instance;
}
function KeyboardCase_Sentences_getInstance() {
  static_init_1();
  return KeyboardCase_Sentences_instance;
}
function KeyboardType_Text_getInstance() {
  static_init_2();
  return KeyboardType_Text_instance;
}
function KeyboardType_Integer_getInstance() {
  static_init_2();
  return KeyboardType_Integer_instance;
}
function KeyboardType_Phone_getInstance() {
  static_init_2();
  return KeyboardType_Phone_instance;
}
function KeyboardType_Decimal_getInstance() {
  static_init_2();
  return KeyboardType_Decimal_instance;
}
function KeyboardType_Email_getInstance() {
  static_init_2();
  return KeyboardType_Email_instance;
}
function KeyboardType_IntegerWithNegative_getInstance() {
  static_init_2();
  return KeyboardType_IntegerWithNegative_instance;
}
function KeyboardType_DecimalWithNegative_getInstance() {
  static_init_2();
  return KeyboardType_DecimalWithNegative_instance;
}
function AutoComplete_Email_getInstance() {
  static_init_3();
  return AutoComplete_Email_instance;
}
function AutoComplete_Password_getInstance() {
  static_init_3();
  return AutoComplete_Password_instance;
}
function AutoComplete_NewPassword_getInstance() {
  static_init_3();
  return AutoComplete_NewPassword_instance;
}
function AutoComplete_OneTimeCode_getInstance() {
  static_init_3();
  return AutoComplete_OneTimeCode_instance;
}
function UrlCacheStrategy_Full_getInstance() {
  static_init_4();
  return UrlCacheStrategy_Full_instance;
}
function ImageScaleType_Fit_getInstance() {
  static_init_5();
  return ImageScaleType_Fit_instance;
}
//region block: init
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  get_entries as get_entries3nqgftw5r4i02,
  Dimension as Dimensions32ju1l7z4mh,
  FontAndStyle as FontAndStyle1comk0qshc8kn,
  Icon as Icon1h1pe6893iwt2,
  ImageLocal as ImageLocal23zvpfzvp93up,
  ImageRaw as ImageRaw13ec2czmt8f60,
  ImageRemote as ImageRemote256pcav1ipbca,
  ImageVector as ImageVector2g5mdtb71xbxl,
  KeyboardHints as KeyboardHints3coyq4x1rsbe3,
  And as And1jik66wmc7j6f,
  DisplayMode as DisplayMode1pn688e4egpke,
  Hover as Hover1ygztk1sofk4b,
  MaxAspectRatio as MaxAspectRatio1wpxrnyd9eji1,
  MaxHeight as MaxHeight3e6pmlm3xkuk4,
  MaxWidth as MaxWidth3w3zqziye9hut,
  MinAspectRatio as MinAspectRatio2013cocyd0aan,
  MinHeight as MinHeight1d4eo0z72v5cz,
  MinWidth as MinWidthmy5c27t0vx62,
  Not as Not1uanfh2ezdtkv,
  Or as Or3j9abhvhjviwp,
  Pointer as Pointer1u5ideccnki5y,
  Update as Updatefnuihmjsla6n,
  SizeConstraints as SizeConstraints24axz83pb17aw,
  div_0 as divkhq3vjih9fcw,
  times_0 as times2ukvaf6yk96p2,
  times_1 as timesx4ey3un7ihw1,
  _Dimension___init__impl__44fy0d as _Dimension___init__impl__44fy0dh4lhk0zw2tim,
  Dimension__compareTo_impl_gsceod as Dimension__compareTo_impl_gsceod30y54irsnvl8x,
  Dimension__hashCode_impl_p583vw as Dimension__hashCode_impl_p583vw23xta4b9uvomj,
  Dimension__toString_impl_o4q1ad as Dimension__toString_impl_o4q1ad26wkwcghhu2zh,
  _Dimension___get_value__impl__urhqzr as _Dimension___get_value__impl__urhqzrblez9tu1bx9v,
  Align_Center_getInstance as Align_Center_getInstance366ihr7rj12mu,
  Align_End_getInstance as Align_End_getInstancer37lklmdzqms,
  Align_Start_getInstance as Align_Start_getInstance48vaevgl3nrq,
  Align_Stretch_getInstance as Align_Stretch_getInstance2huaa6rbagugp,
  AutoComplete_NewPassword_getInstance as AutoComplete_NewPassword_getInstance1yzmcu8by4qcs,
  AutoComplete_OneTimeCode_getInstance as AutoComplete_OneTimeCode_getInstance2jnburz3ronxh,
  AutoComplete_Password_getInstance as AutoComplete_Password_getInstanceyld5z2aqpc6v,
  ImageScaleType_Fit_getInstance as ImageScaleType_Fit_getInstance3ce22z7h47ouq,
  KeyboardCase_Letters_getInstance as KeyboardCase_Letters_getInstance25f79mlixgey5,
  KeyboardType_Text_getInstance as KeyboardType_Text_getInstance1pk95izd69yc4,
  WordBreak_Normal_getInstance as WordBreak_Normal_getInstance3as0xde97pocm,
  Companion_getInstance as Companion_getInstance23x6zslwzj0st,
  Companion_getInstance_2 as Companion_getInstance1toimxkidoujm,
  Companion_getInstance_1 as Companion_getInstance2h9rm1uihk6zf,
};
//endregion

//# sourceMappingURL=data.mjs.map
